var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreenClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.846,
    height: 15.908,
    viewBox: "0 0 15.846 15.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrows-compress",
    d: "M17.121,3.31,13.06,7.371h2.751a.767.767,0,0,1,0,1.535h-4.6a.77.77,0,0,1-.767-.767v-4.6a.767.767,0,1,1,1.535,0V6.286l4.061-4.061A.767.767,0,1,1,17.121,3.31ZM8.431,10.5a.775.775,0,0,0-.293-.059h-4.6a.767.767,0,0,0,0,1.535H6.286L2.225,16.036A.767.767,0,1,0,3.31,17.121L7.371,13.06v2.751a.767.767,0,0,0,1.535,0v-4.6a.767.767,0,0,0-.474-.708Z",
    transform: "translate(-1.75 -1.75)",
    fill: "#212547",
    stroke: "#212547",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenClose);
export default __webpack_public_path__ + "static/media/fullscreen-close.e8549d94cbedc200721504fbf5e81278.svg";
export { ForwardRef as ReactComponent };